<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-tachometer"></i> MRF ON-HOLD Dashboard </div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-cloud-download"></i> Download Report</button> -->
                </div>
            </div>
            <!--end header-->

       <!-- FnF Dashboard-(Region Wise)  -->
            <div class="row row-replace m-t-10 menu-column border border-rad">
                <div class="col-12 bg-primary text-white menu-head border-rad h5 add-p-tb m-b-0">
                   <i class="fa fa-link"></i> MRF On-hold Dashboard-(Region Wise)
                </div>
                <div class="col-12 col-pn">
                   <div class="table-responsive">
                      <table class="table table-align">
                         <thead>
                         <th>Region</th>
                         <th>Total</th>
                         <th>Open > 10 days	</th>
                         <th>Open > 20 days</th>
                         <th>Open > 30 days	</th>
                         <th>Open > 60 days</th>
                         </thead>
                         <tbody>
                            <tr>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                               <td>0</td>
                            </tr>
                         </tbody>
                         
                      </table>
                   </div>
                </div>
             </div>

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

